export default "__VITE_ASSET__BStSN9Me__"